import { LocalStorage } from "./local-storage";

export class CityData {
	private static rawData: Record<string, number>;
	private static cityList: string[];
	private static cityData: { name: string; id: number }[];

	private static load(): Promise<Record<string, number>> {
		if (CityData.rawData) {
			return Promise.resolve(CityData.rawData);
		}

		const cityDataString = LocalStorage.get("bm-city-data");

		if (cityDataString) {
			try {
				CityData.rawData = JSON.parse(cityDataString);

				return Promise.resolve(CityData.rawData);
			} catch (_e) {
				// NOTE: Ha nem valid a JSON akkor mehet tovább
			}
		}

		return import("../../../extra/city-data.json").then((response) => {
			CityData.rawData = response.default;
			LocalStorage.set("bm-city-data", JSON.stringify(CityData.rawData));

			return CityData.rawData;
		});
	}

	public static getList(): Promise<string[]> {
		if (CityData.cityList) {
			return Promise.resolve(CityData.cityList);
		}

		return CityData.load().then((rawData) => {
			CityData.cityList = Object.keys(rawData);

			return CityData.cityList;
		});
	}

	public static getData(): Promise<{ name: string; id: number }[]> {
		if (CityData.cityData) {
			return Promise.resolve(CityData.cityData);
		}

		return CityData.load().then((rawData) => {
			CityData.cityData = Object.keys(rawData).map((cityName) => ({
				name: cityName,
				id: rawData[cityName],
			}));

			return CityData.cityData;
		});
	}

	public static getCityIdByName(cityName: string): Promise<number> {
		if (!cityName) {
			return Promise.reject(new Error("Undefined city name"));
		}
		const simplified = cityName.toLowerCase().trim();

		return CityData.getData().then((list) => list.find((item) => item.name.toLowerCase() === simplified)?.id);
	}

	public static getCityNameById(cityId: string | number): Promise<string> {
		const numberised = Number(`${cityId}`);

		if (isNaN(numberised)) {
			return Promise.reject(new Error());
		}

		return CityData.getData().then((list) => list.find((item) => item.id === numberised)?.name);
	}
}
